/* Bookshelf Treasures — search overlay + predictive results */
(function () {
  const overlay = document.querySelector('[data-bt-search]');
  if (!overlay) return;
  const input = overlay.querySelector('[name="q"]');
  const results = overlay.querySelector('[data-bt-search-results]');
  /* /search/suggest.json returns `price` as a STRING in major units ("45.99"),
     not cents. The old code divided by 100, so $45.99 rendered as $0.46. */
  const toUsd = (raw) => {
    if (raw == null) return null;
    const n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  };

  const open = () => {
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => input && input.focus(), 30);
  };
  const close = () => {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (results) results.innerHTML = '';
    if (input) input.value = '';
  };

  document.querySelectorAll('[data-bt-search-open]').forEach((b) => b.addEventListener('click', open));
  overlay.querySelectorAll('[data-bt-search-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !overlay.hidden) close(); });

  let t;
  input && input.addEventListener('input', () => {
    clearTimeout(t);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    t = setTimeout(() => {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { results.innerHTML = '<p class="bt-sr__a" style="padding:8px">No matches yet — press Enter to search everything.</p>'; return; }
          results.innerHTML = items.map((p) => {
            const img = p.featured_image && p.featured_image.url
              ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">'
              : '<span style="width:38px;height:52px;border-radius:2px;background:#2E4C3E;display:inline-block"></span>';
            /* vendor is always "FreshReads" — noise, not the author, so it's dropped */
            const usd = toUsd(p.price);
            const price = usd == null ? ''
              : '<span class="bt-sr__p" data-bt-money="' + usd.toFixed(2) + '">$' + usd.toFixed(2) + '</span>';
            return '<a class="bt-sr" href="' + p.url + '">' + img +
              '<span><span class="bt-sr__t">' + p.title + '</span></span>' + price + '</a>';
          }).join('');
          /* results render after page load, so re-run the currency converter over them */
          if (window.btCurrency && window.btCurrency.refresh) window.btCurrency.refresh();
        })
        .catch(() => { results.innerHTML = ''; });
    }, 180);
  });
})();
